import { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

/**
 * Hook to manage filters synchronized with URL query parameters
 */
export function useFilters(initialFilters = {}) {
  const [searchParams, setSearchParams] = useSearchParams();
  
  // Initialize filters from URL or defaults
  const getInitialFilters = () => {
    const filters = { ...initialFilters };
    searchParams.forEach((value, key) => {
      filters[key] = value;
    });
    return filters;
  };
  
  const [filters, setFilters] = useState(getInitialFilters);
  
  // Update URL when filters change
  const updateFilters = (newFilters) => {
    setFilters(newFilters);
    
    // Build new search params
    const params = new URLSearchParams();
    Object.entries(newFilters).forEach(([key, value]) => {
      if (value && value !== 'all' && value !== '') {
        params.set(key, value);
      }
    });
    
    setSearchParams(params, { replace: true });
  };
  
  const setFilter = (key, value) => {
    updateFilters({ ...filters, [key]: value });
  };
  
  const resetFilters = () => {
    updateFilters(initialFilters);
  };
  
  return { filters, setFilter, updateFilters, resetFilters };
}
